const defaults = {
  single: true,
};

const enterViewport = (type, el, handler, options = {}) => {
  if (!window.IntersectionObserver) return;

  // console.log('enterViewport', type, el)

  const settings = { ...defaults, ...options };
  let observer;

  const callback = (entries) =>
    entries.forEach((entry = {}) => {
      if (entry.isIntersecting) {
        // console.log('Intersecting')
        // execute the custom handler.
        if (typeof handler === "function") handler();

        // unobserve if its a single use only.
        if (settings.single) observer.unobserve(entry.target);
      }
    });

  const threshold = 0.3; // Default value taken from Editorial tools codebase
  // console.log(`threshold for intersectionObserver for ${type}`, threshold)

  observer = new IntersectionObserver(callback, { threshold });
  el && observer.observe(el);
};

export default enterViewport;
